const Joi = require("joi");

const inmateInfoSchema = Joi.object({
  InmateInvitePublicFrequencyType: Joi.number().greater(0).required().messages({
    "number.greater": "Please choose Frequency type.",
    "any.required": "Please choose Frequency type.",
  }),

  InmateInvitePublicCount: Joi.number()
    .greater(0)
    .empty(null)
    .required()
    .messages({
      "number.greater": "Please enter Limits greater than 0.",
      "any.required": "Please enter Limits.",
      "any.empty": "Please enter Limits.",
    }),

  InvestigatorEmail: Joi.string()
    .allow("")
    .custom((value, helpers) => {
      // Split emails by comma and trim spaces
      const emails = value.split(",").map((email) => email.trim());

      // Validate each email
      for (const email of emails) {
        if (
          !Joi.string()
            .email({ tlds: { allow: false } })
            .validate(email).error
        ) {
          continue;
        }
        return helpers.error("string.email");
      }

      return value; // Return value if all emails are valid
    })
    .messages({
      "string.email": "Please enter  valid E-mail.",
    }),

  // ✅ Request Form Permission Validation
  InmateRequestFormPermission: Joi.array()
    .items(
      Joi.object({
        IActiveStatus: Joi.number()
          .when("OverrideStatus", {
            is: true,
            then: Joi.number().greater(0).required(),
            otherwise: Joi.optional(),
          })
          .messages({
            "number.greater": "Please select any one Status.",
            "any.required": "Please select any one Status.",
          }),
      }).unknown(true)
    )
    .custom((permissions, helpers) => {
      const restrictedTypes = [59, 62];

      const activatedRestrictedForms = permissions.filter(
        (item) =>
          restrictedTypes.includes(item.RequestFormTypeID) &&
          item.OverrideStatus === true &&
          item.IActiveStatus === 1
      );

      if (activatedRestrictedForms.length > 1) {
        return helpers.error("custom.bothFormsActive");
      }

      return permissions;
    })
    .required()
    .messages({
      "any.required": "Please select any one status.",
      "custom.bothFormsActive": "-5", //One of the PDS form is already activated. So, unable to activate the another PDS form.
    }),

  // ✅ Inmate Lock Access Validation
  InmateLockAccess: Joi.array()
    .items(
      Joi.object()
        .keys({
          InmateMenuID: Joi.number().required().messages({
            "any.required": " Please enter InmateMenuID.",
          }),
          LockAccessFrom: Joi.string().trim().required().messages({
            "any.required": "Please enter From Date.",
            "string.empty": "Please enter From Date.",
          }),
          LockAccessTo: Joi.string().trim().required().messages({
            "any.required": "Please enter To Date.",
            "string.empty": "Please enter To Date.",
          }),
        })
        .unknown(true)
    )
    .required()
    .messages({
      "any.required": "Please select InmateLockAccess data.",
    }),
}).unknown(true);


const validateInmateInfo = (data) => {
  const validationResult = inmateInfoSchema.validate(data, {
    abortEarly: false,
  });

  if (validationResult.error) {
    validationResult.error.details = validationResult.error.details.map(
      (err) => {
        // Extract path and find if it contains an array index
        const match = err.path.find((p) => typeof p === "number");

        // ✅ Handle InmateLockAccess Errors (Replace Index with `InmateMenuID`)
        if (match !== undefined && err.path.includes("InmateLockAccess")) {
          if (data.InmateLockAccess && data.InmateLockAccess[match]) {
            const menuId = data.InmateLockAccess[match].InmateMenuID;
            err.path = err.path.map((p) => (p === match ? `${menuId}` : p)); // Replace index with `MenuID`
          }
        }

        // ✅ Handle InmateRequestFormPermission Errors (Keep Index)
        if (
          match !== undefined &&
          err.path.includes("InmateRequestFormPermission")
        ) {
          err.path = err.path.map((p) => (p === match ? `${match}` : p)); // Replace index with formatted value
        }

        return err;
      }
    );
  }

  return validationResult;
};

// ✅ Export both functions
module.exports = { inmateInfoSchema, validateInmateInfo };
